import React from 'react';
import { BadgeAlt as Badge } from '@cargomatic/ui';
import EquipmentTypeBadge from 'components/v2/EquipmentTypeBadge';
import moment from 'moment-timezone';
import { formatStopAction, formatWeight } from './utils';
import { isNil } from 'lodash';
import { Timeline, TimelineDot, TimelineEvent } from 'components/ui/Timeline';
const DEFAULT_TIMEZONE = 'America/Los_Angeles';
function formatDate(date, timezone) {
    if (!date)
        return null;
    const tz = timezone || DEFAULT_TIMEZONE;
    return moment.tz(date, tz).format('L LT z');
}
function filterTimelineItems(items) {
    const canceled = items.find((item) => item.key === 'canceled');
    if (canceled) {
        return [canceled];
    }
    if (items.length > 1) {
        return items.filter((item) => item.key !== 'unstarted');
    }
    return items;
}
function transform(str) {
    switch (str) {
        case '':
            return '';
        case 'pre_pull':
            return 'Pre-Pull';
        case 'stop_off':
            return 'Stop-Off';
    }
    return 'Yard Diversion';
}
export function StopInformation({ shipment }) {
    return (React.createElement("div", { className: "p-6 space-y-4" },
        React.createElement("h3", { className: "font-semibold text-base mb-4" }, "Stop Information"),
        React.createElement("div", { className: "space-y-6" }, shipment.stops.map((stop, index) => (React.createElement("div", { key: index, className: "flex gap-6 items-start" },
            React.createElement("div", { className: "flex flex-col items-center gap-2" },
                React.createElement("div", { className: "flex items-center justify-center w-8 h-8 rounded-full bg-gray-700 text-white font-semibold text-sm" }, stop.sequence),
                index < shipment.stops.length - 1 && (React.createElement("div", { className: "w-0.5 h-12 bg-gray-300" }))),
            React.createElement("div", { className: "flex flex-wrap gap-4" },
                React.createElement("div", { className: "w-40" },
                    React.createElement("div", { className: "text-xs text-muted-foreground mb-1" }, "Intent"),
                    React.createElement("div", { className: "font-medium" }, formatStopAction(stop))),
                React.createElement("div", { className: "w-80" },
                    React.createElement("div", { className: "text-xs text-muted-foreground mb-1" }, "Location"),
                    React.createElement("div", { className: "flex items-center gap-2 mb-1" },
                        React.createElement("div", { className: "font-medium" }, stop.location.name),
                        stop.isOffsite && (React.createElement(Badge, { variant: "outline", className: "bg-orange-100 text-orange-800 border-orange-300 text-xs whitespace-nowrap" }, "Offsite"))),
                    React.createElement("div", { className: "text-sm text-muted-foreground" }, stop.location.address)),
                React.createElement("div", { className: "flex-1" },
                    React.createElement("div", { className: "text-xs text-muted-foreground mb-1" }, "Equipment"),
                    React.createElement("div", { className: "flex flex-wrap gap-2" }, stop.equipmentIds.map((equipment, eqIndex) => (React.createElement("div", { key: eqIndex, className: "flex items-center gap-2" },
                        React.createElement("span", { className: "text-blue-600 font-medium" }, equipment.id),
                        React.createElement(EquipmentTypeBadge, { equipmentType: equipment.containerType })))))),
                React.createElement("div", { className: "w-48" },
                    React.createElement("div", { className: "text-xs text-muted-foreground mb-1" }, "Timeline"),
                    stop.timeline.length === 0 ? (React.createElement("span", { className: "text-muted-foreground" }, "\u2014")) : (React.createElement(Timeline, { className: "" }, filterTimelineItems(stop.timeline).map((entry, i) => (React.createElement(TimelineEvent, { key: i },
                        React.createElement(TimelineDot, null),
                        React.createElement("div", { className: "text-sm font-medium" }, entry.statusMessage),
                        entry.actualDate && (React.createElement("p", { className: "text-gray-700 text-xs" }, formatDate(entry.actualDate, stop.location.timezone)))))))))))))),
        !isNil(shipment.totalWeight) && (React.createElement("div", { className: "mt-6 pt-4 border-t" },
            React.createElement("div", { className: "text-xs text-muted-foreground mb-2" }, "Total Weight"),
            React.createElement("div", { className: "text-sm font-medium" }, formatWeight(shipment.totalWeight, shipment.weightUnit)))),
        !isNil(shipment.specialInstructions) && (React.createElement("div", { className: "mt-6 pt-4 border-t" },
            React.createElement("div", { className: "text-xs text-muted-foreground mb-2" }, "Special Instructions"),
            React.createElement("div", { className: "text-sm" }, shipment.specialInstructions))),
        shipment.hubType ? (React.createElement("div", { className: "mt-6 pt-4 border-t" },
            React.createElement("div", { className: "text-xs text-muted-foreground mb-2" }, "Hub Type"),
            React.createElement("div", { className: "text-sm font-medium" }, transform(shipment.hubType)))) : null));
}
